// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createContainer,
	createStateHook,
	createStore,
	type HookStateFunction,
	type OverrideContainerComponent,
} from '@atlassian/react-sweet-state';
import type { ContainerProps, State } from './ContainerProps.types.tsx';
import { fetchInitialStatus } from './fetchInitialStatus.tsx';

export const initialState: State = {
	loading: false,
	error: undefined,
	migrationStatus: undefined,
};

const store = createStore({
	initialState,
	actions: {},
});

export const CmdbArchitectureStoreContainer: OverrideContainerComponent<ContainerProps> =
	createContainer<State, {}, ContainerProps>(store, {
		onInit: fetchInitialStatus,
	});

export const useCmdbArchitectureStore: HookStateFunction<State, void> = createStateHook(store);

export const useIsNewCmdbArchitecture: HookStateFunction<boolean, void> = createStateHook(store, {
	selector: ({ migrationStatus }) => migrationStatus?.routeToTempeh ?? false,
});
